var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('EChart',{staticClass:"shadow-none m-0",attrs:{"options":_vm.chartOptions,"card":"","header":_vm.$t('numberOfOffers'),"loading":_vm.loading,"tooltip":_vm.$t('chartHeaderTooltip')},on:{"click":_vm.handleChartClick}}),_c('ModalNumberOfOffersItem')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }